import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import ModalReports from '../../components/Reportes/ModalReports';
import ModalUserList from '../../components/Reportes/ModalUserList';
import { consultUsuarios, BusquedaUsu } from "../../funciones/ReportesFunction";

const ListUsuarios = () => {
    const [string, setString] = useState ("")
    const [preloader, setPreloader] = useState ("")
    const [preloaderText, setPreloaderText] = useState ({icon: "fa fa-spinner fa-spin", text: "Cargando lista de usuarios. Esta operación puede tardar en cargar"})
    const [userList, setUserList] = useState ([])
    const [userList2, setUserList2] = useState ([])
    const [openModal, setOpenModal] = useState (false)
    const [disabledButton, setDisabledButton] = useState(true)
    const [min, setMin] = useState(0)
    const [max, setMax] = useState(0)
    const [paginas, setPaginas] = useState([])

    useEffect(() => {
        consultUsuarios((resp) => {
            if (resp.length === 0) setPreloaderText({icon: "", text: "No hay usuarios registrados"})
            
            let contenido=[]
            let min = 0
            let max = 200

            let pags = (resp.length) / 200;
            let pagis = 0;
            pagis = parseInt(pags)
            if (!pags % 1 == 0) pagis ++;

            for (let i = 0; i < pagis; i++){
                let min2 = 0
                if (min > 0) min2 = min + 1

                contenido.push({
                    value: min2, min: min2, max: max, label: `Imprimir desde ${min2} a ${max}`
                })

                if (i === (pagis - 2)){
                    min += 200;
                    max = resp.length;
                }else{
                    min += 200;
                    max += 200;
                }
            }

            setUserList(resp);
            setUserList2(resp);
            setPaginas(contenido);
            setDisabledButton(false);

        })
    }, []);

    const styles = {
        padding: 5, fontSize: 12
    }

    let consultaEst = () => {
        if (string === "") return null;
        
        setPreloader("fa fa-spinner fa-spin")
        BusquedaUsu (string, (resp) => {
            setPreloader("")
            if (resp.length === 0) {
                toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                setPreloaderText({icon: "", text: "La búsqueda no obtuvo resultados"})
                setUserList([])
            }else{
                setUserList(resp);
            }
        })
    }

    let enterTab = () => (e) => {
        if (e.which === 13) consultaEst()
    }

    let lisUsuarios = () => {
        if (userList.length === 0) return (
            <tr>
                <td colSpan ={5} align="center" className="text-danger"><i className={preloaderText.icon}></i> {preloaderText.text}</td>
            </tr>
        )
        
        let noName = (nombre) => {
            let nom = nombre;
            if (nombre === null || nombre === undefined) nom = "";
            return nom
        }

        let TipoUsu = (usu) => {
            switch (usu){
                case "EST":         return "Estudiante"
                case "PROF":        return "Profesor"
                case "DIR":         return "Directivo"
                case "ADMIN":       return "Administrativo"
                case "WEBMASTER":   return "Web Master"
            }
        }

        let fecha = (fecha) => {
            let diaActual = new Date(fecha);

            let day = diaActual.getDate();
            let month = diaActual.getMonth() + 1;
            let year = diaActual.getFullYear();
            if(day < 10) day = '0' + day;
            if(month < 10) month = '0' + month;

            return  day + '/' + month + '/' + year;
        }

        let i = 0;
        return (
            userList.map (option => {
                if (option.ci !== null){
                    i++;
                    return(
                        <tr key={option.id}>
                            <td><strong>{i}</strong></td>
                            <td style={styles}>{`${option.nacionalidad}${option.ci}`}</td>
                            <td style={{padding: 5, fontSize: 11}}>
                                {`${option.nombre_1} ${noName(option.nombre_2)} ${option.apellido_1} ${noName(option.apellido_2)}`}
                                <div className="text-danger" style={{fontSize: 10}}>{`${TipoUsu(option.t_name)} - [${option.email}]`}</div>
                            </td>
                            <td align="center" style={styles}>{option.estado_name}</td>
                            <td align="center" style={styles}>{fecha(option.f_nac)}</td>
                        </tr>
                    )
                }
            })
        )
    }

    let showModal = () => {
        if (openModal === false) return null;

        return (
            <ModalReports
                reporte={<ModalUserList data = {userList2} ini = {min} max = {max}/>}
                titulo="Listado de Usuarios"
                display= "block"
                cerrar = {() => {setOpenModal(false)}}
            />
        )
    }

    let ayuda = () => (
        <Row>
            <Col md ={12} align = "justify">
                En este módulo puedes ver el listado de usuarios registrados en el sistema, el tipo de usuario y alguno de sus datos personales
            </Col>
            <Col md ={12} className="custom-mt-10" align = "justify">
                Puedes consultar un usuario individial, para esto solo debes ingresar un dato en el buscador y presionar la tecla Enter
            </Col>
            <Col md ={12} className="custom-mt-10" align = "justify">
                El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button> permite ver el reporte en formato <strong>Pdf</strong> para su impresión
            </Col>
        </Row>
    )
    
    let styles2 = {
        cursor:"pointer",
        paddingTop:5,
        paddingBottom:5,
        fontSize:12
    }

    let opciones = () => (
        paginas.map(option => (
            <div key = {option.value} className="text-danger" style={styles2} onClick={() => {
                setMin(option.min)
                setMax(option.max)
                setOpenModal(true)
            }} align="justify"><i className="fa fa-print"></i> {option.label}</div>
        ))
    )
    
    let printList = (
        <Popover>
            <div style={{overflowY: "auto", maxHeight:"40vh"}}>{opciones()}</div>
        </Popover>
    )

    return (
        <div className="content">
            <Row>
                <Col md={8}>
                    <div className="custom-alert-info" style={{padding: 5, backgroundColor: "fff"}}>
                        <Row>
                            <Col md={9}>
                                <div>Búsqueda de Usuarios <i className={preloader}></i></div>
                                <input type="text" value ={string} onChange={(e) => {setString(e.target.value)}} onBlur={consultaEst} onKeyPress={enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                            </Col>
                            <Col md={3} align="right" style={{paddingTop: 21}}>
                                <OverlayTrigger trigger="focus" placement="bottom" overlay={printList}>
                                    <button disabled={disabledButton} className="btn btn-primary" title="Imprimir lista" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir<i className="fa fa-caret-down"></i></button>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                    </div>
                    <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY: "auto", maxHeight: "40vh"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="50px" style={styles}><strong>N°</strong></td>
                                <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                <td width="55%" style={styles}><strong>Usuario</strong></td>
                                <td align="center" width="20%" style={styles}><strong>Lug. Nacimiento</strong></td>
                                <td align="center" width="10%" style={styles}><strong>Fecha</strong></td>
                            </tr>
                            {lisUsuarios()}
                        </tbody>
                    </Table>
                    </div>
                </Col>
                <Col md={4}>
                    <div style={{borderRadius: "4px 4px",}}>
                        <CustomCard
                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                            category={<span style={{color: "#fff"}}>Listado de Usuarios</span>}
                            color="#a80012"
                            content={ayuda()}
                        />
                    </div>
                </Col>
            </Row>
            {showModal()}
        </div>
    )
}

export default ListUsuarios;


// WEBPACK FOOTER //
// ./src/views/Reportes/ListUsuarios.jsx